import { render, staticRenderFns } from "./LeaseholderID.vue?vue&type=template&id=0b4a908a&"
import script from "./LeaseholderID.vue?vue&type=script&lang=ts&"
export * from "./LeaseholderID.vue?vue&type=script&lang=ts&"
import style0 from "./LeaseholderID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports